import React, { useEffect, useRef, useCallback, useState } from "react";
import DatePickerComponent from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";
import globalColors from "../../../_metronic/_assets/sass/custom/globalColors.scss";
import { FiCalendar } from "react-icons/fi";
import { pt } from "date-fns/locale";
import * as moment from "moment";
import styles2 from "./styles.module.scss";

export const DatePicker = ({
  placeholder,
  change,
  popAuto,
  range,
  icon,
  name,
  label,
  role,
  error,
  minDate,
  dateStart,
  dateFinal,
  inputValue,
  isDisabled,
}) => {
  const [value, setValue] = useState(inputValue ? inputValue : null);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const datePickerRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const onChange = (date) => {
    console.log("onChange date", date);
    if (date === null) {
      setValue("");
    }
    date = date.replace(/[^0-9]/g, "");
    const day = date.substring(0, 2);
    const month = date.substring(2, 4);
    const year = date.substring(4, 8);

    const tempDate = new Date();
    if (day) {
      tempDate.setDate(day);
    }
    if (month) {
      tempDate.setMonth(month - 1);
    }
    if (year) {
      tempDate.setFullYear(year);
    }
    if (date.length === 8) {
      const selected = moment(`${day}/${month}/${year}`, "DD/MM/YYYY").toDate();
      console.log("selected", selected);
      setSelectedDate(selected);

      date = `${day}/${month}/${year}`;
    }

    setValue(date);
    setSelectedDate(tempDate);

    if (moment(date, "DD/MM/YYYY").isValid()) {
      const selected = moment(date, "DD/MM/YYYY").toDate();
      setSelectedDate(selected);
      setTimeout(() => {
        datePickerRef.current.setBlur(true);
        datePickerRef.current.setFocus(true);
      }, 300);
      setValue(date);
      change(date);
    } else {
      setSelectedDate(null);
      change(null);
    }
    setTimeout(() => {
      setOpen(false);
      setOpen(true);
    }, 300);
  };

  useEffect(() => {
    if (moment(value, "DD/MM/YYYY").isValid()) {
      const selected = moment(value, "DD/MM/YYYY").toDate();
      setSelectedDate(selected);
    } else {
      setSelectedDate(null);
    }
  }, [value]);

  const formartLabel = label => {
    if (!label?.includes("*")) return [label, null];

    return [
      label.substring(0, label.length - 1),
      label.substring(label.length - 1)
    ];
  };

  useEffect(() => {
    if (dateStart) {
      setValue(dateStart);
    }
  }, [dateStart]);

  useEffect(() => {
    if (dateFinal) {
      setValue(dateFinal);
    }
  }, [dateFinal]);

  useEffect(() => {
    if (inputValue) {
      setValue(inputValue);
    }
  }, [inputValue]);

  return (
    <div className={styles2.inputContainer} ref={wrapperRef}
      onFocus={() => { setOpen(true) }}
      style={{
        width: "100% ",
        padding: "0",
      }}
    >
      <div
        className={styles2.divInput}
        role={role}
        style={{
          width: "100% ",
          padding: "0",
        }}
      >
        <label
          htmlFor={name}
          style={{
            padding: "0 5px"
          }}
        >
          {formartLabel(label)[0]}
          <span>{formartLabel(label)[1]}</span>
        </label>
        <DatePickerComponent
          onClick={() => setOpen(!open)}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
            width: "100% ",
          }}
          onBlur={() => setOpen(false)}
          className={styles2.input}
          placeholderText={placeholder}
          ref={datePickerRef}
          selected={selectedDate}
          value={value}
          onChangeRaw={e => onChange(e.target.value)}
          disabled={isDisabled}
          customInput={
            <div style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              width: "100% ",
            }}>
              <input
                className={styles2.input}
                disabled={isDisabled}
                value={value}
                onFocus={() => { setOpen(true) }}
                placeholder={placeholder}
                onKeyDown={(e) => {
                  if (e.keyCode === 13 || e.keyCode === 9) {
                    e.preventDefault();
                    e.target.blur();
                    setOpen(false);
                  }
                }}
                style={{
                  width: "100% ",
                }}
                tabIndex="-1"
              />
              <FiCalendar color={globalColors.backgroundColor2} style={{
                position: "absolute",
                right: "20px",
              }} />
            </div>
          }
          customInputRef={inputRef}
          dateFormat="dd/MM/yyyy"
          popperClassName="datetime-popper"
          popperPlacement="left-start"
          popperModifiers={{
            offset: {
              enabled: true,
              offset: "0px, 0px",
            },
            flip: {
              behavior: ["bottom"],
            },
            preventOverflow: {
              enabled: true,
              escapeWithReference: false,
              boundariesElement: "viewport",
            },

          }}
          showPopperArrow={false}
          locale={pt}
          closeOnScroll={true}
          calendarStartDay={0}
          isClearable={false}
          minDate={minDate}
          open={open}
          shouldCloseOnSelect={true}
        />
      </div>
      {role === "notOk" && <span className={styles2.textError}>Data Inválida!</span>}
    </div>
  );
};

export default DatePicker;
